import { render, staticRenderFns } from "./BackgroundJobs.vue?vue&type=template&id=22430fe6&scoped=true"
import script from "./BackgroundJobs.vue?vue&type=script&lang=js"
export * from "./BackgroundJobs.vue?vue&type=script&lang=js"
import style0 from "./BackgroundJobs.vue?vue&type=style&index=0&id=22430fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22430fe6",
  null
  
)

export default component.exports